<template>
  <div
    class="sys-tooltip-wrapper2"
    @mouseenter="show"
    @mouseleave="hide"
  >
    <slot name="activator" :on="{}" :attrs="{}"></slot>

    <transition name="fade">
      <div
        v-if="isVisible && !disabled"
        class="sys-tooltip-content2"
        :class="positionClass"
      >
        <div v-if="title" class="sys-tooltip-title2">{{ title }}</div>
        <div class="sys-tooltip-text2">{{ text }}</div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "SysTooltip2",
  props: {
    title: { type: String, default: "" },
    text: { type: String, required: true },
    disabled: { type: Boolean, default: false },
    bottom: { type: Boolean, default: false },
    top: { type: Boolean, default: false },
    left: { type: Boolean, default: false },
    right: { type: Boolean, default: false },
  },
  data() {
    return { isVisible: false };
  },
  computed: {
    positionClass() {
      if (this.bottom) return "sys-tooltip-bottom2";
      if (this.left) return "sys-tooltip-left2";
      if (this.right) return "sys-tooltip-right2";

      return "sys-tooltip-top2";
    },
  },
  methods: {
    show() {
      this.isVisible = true;
    },
    hide() {
      this.isVisible = false;
    },
  },
};
</script>

<style scoped>
.sys-tooltip-wrapper2 {
  position: relative;
  display: inline-block;
}

.sys-tooltip-content2 {
  position: absolute;
  z-index: 9999;
  text-align: center;

  background: #2f343b;
  color: #ffffff;
  border-radius: 8px;
  padding: 8px 12px;

  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.22);

  min-width: 290px;
  max-width: 560px;

  letter-spacing: 0.2px;
}

.sys-tooltip-title2 {
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 4px;
}

.sys-tooltip-text2 {
  font-weight: 400;
  font-size: 13px;
  line-height: 1.25;
  white-space: normal;
}

.sys-tooltip-content2::before {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
}

.sys-tooltip-top2 {
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 10px;
}

.sys-tooltip-top2::before {
  left: 50%;
  top: 95%;
  transform: translateX(-50%);
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #2f343b;
}

.sys-tooltip-top2::after {
  left: -26px;
  top: 50%;
  transform: translateY(-50%);
}

.sys-tooltip-bottom2 {
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 10px;
}

.sys-tooltip-bottom2::before {
  left: 50%;
  bottom: 100%;
  transform: translateX(-50%);
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #2f343b;
}

.sys-tooltip-bottom2::after {
  left: -26px;
  top: 50%;
  transform: translateY(-50%);
}

.sys-tooltip-left2 {
  top: 50%;
  right: 100%;
  transform: translateY(-50%);
  margin-right: 12px;
}

.sys-tooltip-left2::before {
  left: 99%;
  top: 50%;
  transform: translateY(-50%);
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 10px solid #2f343b;
}

.sys-tooltip-left2::after {
  left: -26px;
  top: 50%;
  transform: translateY(-50%);
}

.sys-tooltip-right2 {
  top: 50%;
  left: 100%;
  transform: translateY(-50%);
  margin-left: 12px;
}

.sys-tooltip-right2::before {
  right: 99%;
  top: 50%;
  transform: translateY(-50%);
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 10px solid #2f343b;
}

.sys-tooltip-right2::after {
  left: -26px;
  top: 50%;
  transform: translateY(-50%);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.14s ease, transform 0.14s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
